import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  onClick?: () => void;
  className?: string;
  showArrow?: boolean;
  disabled?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  className = '',
  showArrow = false,
  disabled = false
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-200 rounded';
  const variants = {
    primary: 'bg-amber hover:bg-amber-dark text-navy shadow-lg hover:shadow-xl',
    secondary: 'bg-navy hover:bg-navy-light text-white shadow-lg hover:shadow-xl',
    outline: 'border-2 border-navy text-navy hover:bg-navy hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-base md:text-lg'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`;
  const content = <>
      {children}
      {showArrow && <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-1056" />}
    </>;
  if (href) {
    return <a href={href} className={classes} data-id="element-1057">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={classes} disabled={disabled} data-id="element-1058">
      {content}
    </button>;
}